import React from 'react'
import { Stack } from './stackflow/stackflow'

const App: React.FC = () => {
  return <Stack />
}

export default App
